import { getSalePaymentTotals, getCustomerNameById } from './salesRepoDetail';

/**
 * Puerto de enrich para detalle de venta (ADR-017 remote-only).
 * No lee SQLite: stubs de allocations + nombre de cliente.
 */
export const salesEnrichAdapter = {
  async countSalePaymentAllocations(_saleId: string) {
    return 0;
  },
  getSalePaymentTotals,
  async getCustomerName(customerId: string) {
    return getCustomerNameById(customerId);
  },
};
